"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleValueAddControl = void 0;
var react_1 = __importStar(require("react"));
var Button_1 = require("../../Button");
var Input_1 = require("../../forms/Input");
var SingleValueAddControl = function (props) {
    var _a = react_1.useState(""), inputValue = _a[0], setInputValue = _a[1];
    var add = function () {
        if (inputValue) {
            return props.onAddFromInlineValue(inputValue);
        }
    };
    return (react_1.default.createElement("div", { className: "c-dropdown__add +inline" },
        react_1.default.createElement(Input_1.Input, { type: "text", value: inputValue, autoFocus: true, className: "c-dropdown__add-input +fill", onChange: function (e) { return setInputValue(e.target.value); }, onKeyPress: function (e) {
                if (e.key == "Enter") {
                    e.preventDefault();
                    add();
                }
            } }),
        react_1.default.createElement("div", { className: "c-dropdown__add-buttons" },
            react_1.default.createElement(Button_1.Button, { onClick: props.onCancel, className: "+quiet +ghost +small" }, "Cancel"),
            react_1.default.createElement(Button_1.Button, { onClick: add, className: "+small +icon" },
                react_1.default.createElement("span", { className: "c-button__icon" }, "+"),
                " ",
                react_1.default.createElement("span", { className: "c-button__text" }, "Add")))));
};
exports.SingleValueAddControl = SingleValueAddControl;
//# sourceMappingURL=AddControl.js.map